// extracted by mini-css-extract-plugin
export default {"navparent":"Tabs_navparent__6cMMj","link":"Tabs_link__ah6fL","nav-tabs":"Tabs_nav-tabs__A+QkP","active":"Tabs_active__4iL-M"};